module.exports = __webpack_public_path__ + "static/media/Love-Coding.2574f75c.webm";